import { openAndUpdateModal } from '_common/modals/ModalsSlice';
import {
  OnboardingEnvironments,
  selectShouldShowFirstAccessModal,
} from 'App/redux/onboardingSlice';
import { useEffect } from 'react';
import { useDispatch, useSelector } from '_common/hooks';

export const useFirstAccessModal = (product: Exclude<OnboardingEnvironments, 'explorer'>) => {
  const dispatch = useDispatch();

  const showModal = useSelector((state) => selectShouldShowFirstAccessModal(state, product));

  useEffect(() => {
    if (showModal) {
      dispatch(openAndUpdateModal({ modal: 'FirstAccessModal', data: { location: product } }));
    }
  }, [showModal]);
};
